var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"},on:{"click":_vm.clicked}},[_c('b-img',{attrs:{"src":_vm.image,"id":"image","rounded":"circle","alt":"motabhai"}}),_c('h2',{attrs:{"id":"username"}},[_vm._v(_vm._s(_vm.name))]),(_vm.show)?_c('b-icon',{attrs:{"icon":"check-circle-fill","id":"icon"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }